import { isAPIValidationError } from '@sales-center/common'
import { createSystemOpportunityName } from '@user/components/Opportunities/OpportunityName/functions'
import { useAppDispatch } from '@user/store/hooks'
import { ILeadOppProduct } from '@user/store/leadOppProducts'
import { updateName } from '@user/store/opportunity'
import { FormikErrors } from 'formik'
import { useCallback } from 'react'
import { toast } from '@sales-center/components'
import { EditOpportunityNameFormModel } from '../EditOpportunityNameFormWrapper'
type Props = {
  id: number
  onClose: () => void
  services: ILeadOppProduct[]
}
export function useHandlers(props: Props) {
  const { id, onClose, services } = props
  const dispatch = useAppDispatch()

  const validate = useCallback((model: EditOpportunityNameFormModel) => {
    const errors: FormikErrors<EditOpportunityNameFormModel> = {}
    const { opportunityName, useSystemName } = model

    if (useSystemName === 'false' && opportunityName.trim() === '') {
      errors.opportunityName = 'Please enter a name.'
    }
    if (useSystemName === 'false' && opportunityName.length > 100) {
      errors.opportunityName = 'Name cannot exceed 100 characters'
    }

    return errors
  }, [])

  const onSubmit = useCallback(
    async (model: EditOpportunityNameFormModel) => {
      const input = {
        id: id,
        name:
          model.useSystemName === 'true'
            ? createSystemOpportunityName(services)
            : model.opportunityName,
        useSystemName: model.useSystemName === 'true',
      }

      const response = await dispatch(updateName(input))

      if (updateName.fulfilled.match(response)) {
        toast.success('Opportunity name updated.')
        onClose()
      } else {
        const { payload } = response
        if (!!payload) {
          if (isAPIValidationError(payload)) {
            const { errors } = payload
            if (errors && errors['Name']) {
              toast.error(errors['Name'].join(', '))
            }
          }
        } else {
          toast.success('Failed to update opportunity name.')
        }
      }
    },
    [id, dispatch, onClose, services],
  )

  return {
    validate,
    onSubmit,
  }
}
